var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"flex-none text-lg text-right cursor-pointer px-3 py-3"},[_vm._v("\n            Testing\n        ")])])])}]

export { render, staticRenderFns }